/* eslint-disable */
// ─── Normalizer ───────────────────────────────────────────────────────────────
// Pure function. Idempotent. No side effects.

/**
 * Normalize raw user input for consistent downstream processing.
 * - Trim outer whitespace
 * - Lowercase
 * - Collapse repeated whitespace into single space
 * - Strip control characters
 * - Preserve hyphens (needed for P-1023, AC.L1-3.1.1)
 * - Preserve dots (needed for control IDs like 3.1.1, A.9.1)
 * - Strip other punctuation that's not semantically meaningful
 */
export function normalize(input) {
    return input
        .trim()
        // Strip control characters / zero-width spaces
        .replace(/[ -​-‍﻿]/g, '')
        // Lowercase
        .toLowerCase()
        // Normalize unicode quotes / apostrophes to ascii
        .replace(/[‘’‚‛]/g, "'")
        .replace(/[“”„‟]/g, '"')
        // Remove quotes (they wrap policy titles but we extract separately)
        .replace(/["']/g, '')
        // Remove punctuation except: hyphen, dot, forward slash, question mark, underscore
        // (keep ? for help detection, / for route-like commands, - and . for IDs)
        .replace(/[^\w\s\-./?À-ɏ]/g, ' ')
        // Collapse whitespace
        .replace(/\s{2,}/g, ' ')
        .trim();
}
